import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import {
    selectHasMembersCalendarSummarizationReceivePermission,
    selectHasSummarizationSettingsPermission,
    setCalendarSummarizationForMembersAllowed,
} from '../../../../../../pages/call/features/permissions';
import { selectIsSummarizationAvailable } from '../../../../../../pages/call/features/summarization';
import { Switch } from '../../../../../components';
import { i18n } from '../../../../../helpers/i18n';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../flags/selectors';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import styles from './styles.css';

export const CalendarSummarizationSwitcher: FunctionComponent = () => {
    const isSummarizationAvailable = useSelector(selectIsSummarizationAvailable);
    const hasMembersPermission = useSelector(selectHasMembersCalendarSummarizationReceivePermission);
    const hasSummarizationSettingsPermission = useSelector(selectHasSummarizationSettingsPermission);

    const onChange = useOnPermissionChange(
        setCalendarSummarizationForMembersAllowed,
        'summarization_mail_for_participants_from_calendar'
    );

    const calendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);

    if (!isSummarizationAvailable || !hasSummarizationSettingsPermission || !calendarSummarizationFeatureEnabled) {
        return null;
    }

    return (
        <Switch
            className={styles.switch}
            labelAfter={i18n('settings-v2', 'receive-calendar-summary-on-mail')}
            checked={hasMembersPermission}
            onChange={onChange}
            size="sm"
            stretch
            shrink
        />
    );
};
